module.exports = __webpack_public_path__ + "static/media/hacker-news.e3d12564.svg";